import React from 'react';
import { Generic, JSONLD } from 'react-structured-data';

import buildBreadcrumbListItem from './buildBreadcrumbListItem';
import routes from '../../config/routes';
import { STRUCTURED_DATA_HOMEPAGE_BREADCRUMB_ITEM } from './constants';

const PrivacyPolicyEnPageBreadcrumb = () => {
  const privacyPolicyEnPageListItem = buildBreadcrumbListItem({ name: 'Privacy Policy', position: 2, url: routes.privacyPolicyEn });

  const schema = {
    itemListElement: [STRUCTURED_DATA_HOMEPAGE_BREADCRUMB_ITEM, privacyPolicyEnPageListItem],
  };

  return (
    <JSONLD dangerouslyExposeHtml={true}>
      <Generic jsonldtype="BreadcrumbList" schema={schema} />
    </JSONLD>
  );
};

export default PrivacyPolicyEnPageBreadcrumb;
